/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ priority: NonNullable<unknown> }} Spaces_Folder_Priority_Inherit_FromInputs */



/**
* | output |
* | --- |
* | "Inherit ({priority})" |
*
* @param {Spaces_Folder_Priority_Inherit_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_folder_priority_inherit_from = /** @type {((inputs: Spaces_Folder_Priority_Inherit_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Folder_Priority_Inherit_FromInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Übernehmen (${i?.priority})`)
	return /** @type {LocalizedString} */ (`Inherit (${i?.priority})`)
});